import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';

interface VerificationHeaderProps {
  title: string;
  subtitle: string;
}

const VerificationHeader: React.FC<VerificationHeaderProps> = ({
  title,
  subtitle,
}) => {
  const theme = useTheme();
  const smScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box mt={6} mb={2} textAlign="center">
      <Typography
        fontFamily="Lufga"
        fontWeight="500"
        fontSize={smScreen ? '24px' : '32px'}
        color="var(--primary-blue)"
        textAlign="center"
      >
        {title}
      </Typography>

      <Typography
        fontFamily="Nunito Sans"
        fontWeight="400"
        fontSize="16px"
        color="var(--instructions)"
        mt={3}
        textAlign="center"
      >
        {subtitle}
      </Typography>
    </Box>
  );
};

export default VerificationHeader;
